(function () {
    'use strict';

    angular
        .module('app')
        .factory('Task', TaskFactory);

    TaskFactory.$inject = [
        '$q',
        'TasksService',
        'ChilliUserProfileService'];

    function TaskFactory(
        $q,
        TasksService,
        ChilliUserProfileService) {

        /**
         * Copies an existing Task.
         *
         * @param {number} taskId
         *
         * @returns {Promise} A promise that resolves a new {Task} object copied from the specified taskId.
         */
        function copyTask(taskId) {
            return TasksService.get(taskId)
                .then(function (data) {
                    data.Id = null;
                    delete data.UpdatedBy;
                    delete data.UpdatedDate;
                    delete data.CreatedBy;
                    delete data.CreatedDate;
                    var task = new Task(data);
                    task.taskIsNew = true;
                    return $q.when(task);
                });
        }

        /*
         * Determines if the Due Date/Name need to be shown in non-standard colour and if so what colour is to be used.
         * When the task is overdue, red should be used.
         * When the task is due the current day, orange should be used.
         *
         * @param {bool} taskCompleted
         * @param {date} taskDue
         *
         * @returns {string} - Returns what colour should be used for displaying the tasks Due Date/Name
         */
        function getDueDateColour(taskCompleted, taskDue) {
            var result = '';

            if (!taskCompleted && !_.isNil(taskDue)) {
                if (moment().isAfter(taskDue)) {
                    result = 'red';
                } else if (moment().isSame(taskDue, 'day')) {
                    result = 'orange';
                }
            }

            return result;
        }

        /**
         * Get an existing Task.
         *
         * @param {number} taskId
         *
         * @returns {Promise} A promise that resolves a {Task} object for the specified taskId.
         */
        function get(taskId) {
            return TasksService.get(taskId)
                .then(function (data) {
                    return $q.when(new Task(data));
                });
        }

        /**
         * Get a new Task.
         *
         * @param {number} entityId - If supplied it will be used to populate the Link property
         *
         * @returns {Promise} A promise that resolves a new {Task} object. The due date defaults to midday of the current day
         */
        function getNew(entityId) {
            var task = new Task();

            if (!_.isNil(entityId) && entityId !== '') {
                task.data.Link = parseInt(entityId);
            }

            // Set the tasks due date to be 
            var currentDate = new Date();
            var year = currentDate.getFullYear();
            var month = currentDate.getMonth();
            var day = currentDate.getDate();
            var hour = currentDate.getHours();
            var minute = currentDate.getMinutes();
            task.data.Due = new Date(year, month, day, 12, 0);
            task.data.Tags = [];

            return ChilliUserProfileService.getUserProfile()
                        .then(function (data) {
                            task.data.AssignedTo.push(data.Id);
                            return $q.when(task);
                        });
        }

        /**
         * @constructor
         *
         * @property {Object} data - Task data, refer C# class 'Task'.
         */
        function Task(data) {
            var vm = this;
            vm.save = save;
            Object.defineProperty(vm, 'taskPersisted', { get: getTaskPersisted });

            if (!_.isNil(data)) {
                vm.data = data;
            } else {
                vm.data = newTask();
                vm.taskIsNew = true;
            }

            /**
             * Saves task.
             * If the task is currently being saved, another save request will be chained onto the promise
             *
             * @returns {Promise} Promise that will be resolved to a response object when the save request succeeds or fails.
             */
            function save() {
                if (_.isNil(save.savePromise)) {
                    var currentTask = angular.copy(vm.data);

                    var taskSavePromise = TasksService.save(currentTask)
                        .then(saveTaskOk, saveTaskError);

                    save.savePromise = taskSavePromise;

                    return taskSavePromise;
                } else {
                    save.savePromise.then(function () {
                        return save();
                    }, function () {
                        return save();
                    });
                }

                function saveTaskOk(response) {
                    vm.data.Id = response.Id;
                    currentTask.Id = response.Id;
                    vm.savedData = angular.copy(currentTask);
                    save.savePromise = null;

                    return response;
                }

                function saveTaskError(response) {
                    save.savePromise = null;

                    return $q.reject(response);
                }
            }

            /**
             * Checks if the task has been persisted
             *
             * @returns {bool} - Returns true if the task has been persisted
             */
            function getTaskPersisted() {
                var result = false;

                if (!_.isNil(vm.data.Id)) {
                    result = true;
                }

                return result;
            }

            /**
             * Creates a new task object with the default values populated
             *
             * @returns {object} - Returns a new task with defaults populated
             */
            function newTask() {
                return {
                    Name: '',
                    Description: '',
                    Link: null,
                    AssignedTo: [],
                    Due: null,
                    Completed: false,
                    Note: '',
                    Frequency: 'Once',
                    RepeatDetails: null
                };
            }
        }

        Task.prototype = {};
        Task.prototype.constructor = Task;

        Task.get = get;
        Task.getNew = getNew;
        Task.copyTask = copyTask;
        Task.getDueDateColour = getDueDateColour;

        return Task;
    }
})();